module.exports = __webpack_public_path__ + "img/askmebet-support.d3fa09a8.png";